export default "__VITE_ASSET__365c1cf0__"